module.exports = __webpack_public_path__ + "media/images/rema-6-9ad094ef61f6833c34fcedd2774eaf44.jpg";